module.exports = __webpack_public_path__ + "img/sucesso_cadastro.7c8a70a0.svg";